import {configureStore} from '@reduxjs/toolkit'
import rootReducer from './reducers'
import {expressApi} from './api/express-api'
import {fiasApi} from './api/fias-api'

const store = configureStore({
    reducer: rootReducer,
    devTools: true,
    middleware: getDefaultMiddleware =>
        getDefaultMiddleware({
            serializableCheck: false,
        }).concat(expressApi.middleware, fiasApi.middleware),
})

export type StoreType = typeof store
export type AppDispatch = typeof store.dispatch

export default store
